import React, { Component } from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import reducers from './reducers';
import {createStore,applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import ReduxThunk from 'redux-thunk';
import Login from "./userinterface/Login";
import ClinicView from "./userinterface/ClinicView";
import SwanView from "./userinterface/SwanView";
import AdminView from "./userinterface/AdminView";
import PCLView from "./userinterface/PCLView";
class App extends Component {

  render() {
    const store = createStore(reducers,{},applyMiddleware(ReduxThunk));
    return (
      <Provider store={store}>
        <HashRouter>
          <Switch>
            <Route exact path="/">
              <Login />
            </Route>

            <Route exact path="/ClinicView">
              <ClinicView />
            </Route>

            <Route exact path="/SwanView">
              <SwanView />
            </Route>

            <Route exact path="/AdminView">
              <AdminView />
            </Route>

            <Route exact path="/PCLView">
              <PCLView />
            </Route>

          </Switch>
        </HashRouter>
      </Provider>
    );
  }
}

export default App;
